import {useSelector} from 'react-redux'

/**
 * Custom React Hook to get random.org API response from state.
 * @see https://reactjs.org/docs/hooks-custom.html
 */
const useModalAPI = () => useSelector(state => state.openModal)

export default useModalAPI

export const useFrameAPI = () => useSelector(state => state.openFrame)

export const useModalVideoAPI = () => useSelector(state => state.openModalVideo)

export const useModalDialogAPI = () => useSelector(state => state.modalDialogStatus)

export const usePopupLocateCityAPI = () => useSelector(state => state.popupLocateCityStatus)

export const useSubscriptionStatusAPI = () => useSelector(state => state.subscriptionStatus)